import React, { Component } from 'react';

import SelectDoorsPermissions from './selectDoorsPermissions';
import SelectUsersPermissions from './selectUsersPermissions';
import SelectAccessTypePermissions from './selectAccessTypePermissions';
import ConfirmationPermissions from './confirmationPermissions';

const PAGE_SELECT_DOORS        = 1;
const PAGE_SELECT_USERS        = 2;
const PAGE_REMOTES_ACCESS_TYPE = 3;
const PAGE_CONFIRMATION        = 4;

export default class PermissionMain extends Component
{
    constructor(props)
    {
        super(props);

        this.state =
        {
            page: PAGE_SELECT_DOORS,
            selectedDoors: [],
            permissionIds: [],
            permissions: [],
            users: [],
            usersByInvitation: [],
            permission: null,
            selectedSubscription: null,

            closePermissions: props.closePermissions
        }
    }
    componentDidMount()
    {
        if (this.props.door != null)
        {
            this.setState(
            {
                selectedDoors: this.state.selectedDoors.concat(this.props.door),
                page: PAGE_SELECT_USERS
            })
        }

        /*if (this.props.permissions != null)
        {
            this.setState({ permissions: this.state.permissions.concat(this.props.permissions) })
        }*/
    }
    componentDidUpdate(prevProps, prevState)
    {
        if (prevProps.door != this.props.door)
        {
            this.setState(
            {
                selectedDoors: this.state.selectedDoors.concat(this.props.door),
                page: PAGE_SELECT_USERS
            })
        }
    }

    render()
    {
        const selectDoors = <div style={{display: (this.state.page === PAGE_SELECT_DOORS) ? 'unset' : 'none'}}>
                                <SelectDoorsPermissions
                                    houses={this.props.houses}
                                    onDoorsSelected={this.onDoorsSelected.bind(this)}
                                    closePermissions={this.state.closePermissions}
                                    detailRemotesOpenDoorId={this.props.door != null ? this.props.door.id : undefined}
                                />
                            </div>
    
        const selectUsers = (this.state.page === PAGE_SELECT_USERS) ?
                                <div style={{display: (this.state.page === PAGE_SELECT_USERS) ? 'unset' : 'none'}}>
                                    <SelectUsersPermissions
                                        houses={this.props.houses}
                                        selectedDoors={this.state.selectedDoors}
                                        onUsersSelected={this.onUsersSelected.bind(this)}
                                        closePermissions={this.state.closePermissions}
                                        goBack={() => this.setState({ page: PAGE_SELECT_DOORS })}
                                    />
                                </div> : null

        const selectAccessType = (this.state.page === PAGE_REMOTES_ACCESS_TYPE) ?
                                    <div style={{display: (this.state.page === PAGE_REMOTES_ACCESS_TYPE) ? 'unset' : 'none'}}>
                                        <SelectAccessTypePermissions
                                            selectedDoors={this.state.selectedDoors}
                                            users={this.state.users}
                                            usersByInvitation={this.state.usersByInvitation}
                                            permissions={this.state.permissions}
                                            confirmPermission={this.confirmPermission.bind(this)}
                                            closePermissions={this.state.closePermissions}
                                            onSubscriptionSelected={(sub) => this.setState({ selectedSubscription: sub })}
                                            goBack={() => this.setState({ page: PAGE_SELECT_USERS })}
                                         />
                                    </div> : null

        const confirmation = (this.state.page === PAGE_CONFIRMATION) ?
                                <div style={{display: (this.state.page === PAGE_CONFIRMATION) ? 'unset' : 'none'}}>
                                    <ConfirmationPermissions
                                        selectedDoors={this.state.selectedDoors}
                                        users={this.state.users}
                                        usersByInvitation={this.state.usersByInvitation}
                                        permissionIds={this.state.permissionIds}
                                        permission={this.state.permission}
                                        onEditPermissions={this.onEditPermissions.bind(this)}
                                        closePermissions={this.state.closePermissions}
                                        selectedSubscription={this.state.selectedSubscription}
                                        goBack={() => this.setState({ page: PAGE_REMOTES_ACCESS_TYPE })}
                                     />
                                </div> : null

        return (
            <>
                { selectDoors }
                { selectUsers }
                { selectAccessType }
                { confirmation }
            </>
        )
    }

    onDoorsSelected(selectedDoors)
    {
        this.setState({
            selectedDoors: selectedDoors,
            page: PAGE_SELECT_USERS
        })
        this.getPermissionsIds(selectedDoors)
    }

    getPermissionsIds(doors)
    {
        doors.map((door) =>
        {
            this.setState({
                permissionId: this.state.permissionIds.push(door.permissionId)
            })
        })
    }

    onUsersSelected(users, usersByInvitation)
    {
        this.setState(
        {
            users: users,
            usersByInvitation: usersByInvitation,
            page: PAGE_REMOTES_ACCESS_TYPE
        })
    }

    confirmPermission(permission)
    {
        this.setState(
        {
            permission: permission,
            page: PAGE_CONFIRMATION
        })
    }

    onEditPermissions()
    {
        this.state.doors.length = 0;
        this.state.users.length = 0;
        this.state.usersByInvitation = 0;

        this.setState({
            permission: null,
            page: PAGE_SELECT_DOORS
        })
    }
}